import {
  DELETE_REPORT,
  DELETE_REPORT_FAILURE,
  DELETE_REPORT_SUCCESS,
  GET_REPORTS,
  GET_REPORTS_FAILURE,
  GET_REPORTS_SUCCESS,
  REPLY_REPORT,
  REPLY_REPORT_FAILURE,
  REPLY_REPORT_SUCCESS,
} from "../constants";

export default class ReportAction {
  static getReports(payload, cb) {
    return {
      type: GET_REPORTS,
      payload,
      cb,
    };
  }
  static getReportsSuccess(payload) {
    return {
      type: GET_REPORTS_SUCCESS,
      payload,
    };
  }
  static getReportsFailure() {
    return {
      type: GET_REPORTS_FAILURE,
    };
  }

  static deleteReport(id, cb) {
    return {
      type: DELETE_REPORT,
      id,
      cb,
    };
  }
  static deleteReportSuccess(payload) {
    return {
      type: DELETE_REPORT_SUCCESS,
      payload,
    };
  }
  static deleteReportFailure() {
    return {
      type: DELETE_REPORT_FAILURE,
    };
  }

  static replyReport(payload, cb) {
    return {
      type: REPLY_REPORT,
      payload,
      cb,
    };
  }
  static replyReportSuccess(payload) {
    return {
      type: REPLY_REPORT_SUCCESS,
      payload,
    };
  }
  static replyReportFailure() {
    return {
      type: REPLY_REPORT_FAILURE,
    };
  }
}
